"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _LoadCalculator = _interopRequireDefault(require("../../components/LoadCalculator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 *  A react component to create a Calculator Accordion
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} Calculator Accordion
 */

function CalculatorAccordion(props) {
  var extractedFields;
  var [item, setItem] = (0, _react.useState)('0');
  var handleItemClick = eventKey => () => {
    setItem(item === eventKey ? null : eventKey);
  };
  if (props.rendering.fields) {
    extractedFields = (0, _utils.extractFieldsFn)(props);
    var mainBody = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, {
      defaultActiveKey: "0"
    }, (0, _lodash.map)(extractedFields.Calculators, (calc, calcKey) => {
      return !(0, _lodash.isEmpty)(calc.fields.StepsContent) && !(0, _lodash.isNull)(calc.fields.Type) && /*#__PURE__*/_react.default.createElement("div", {
        key: "accordion-calc-".concat(calcKey),
        className: "mm-collapse no-border-top ".concat(extractedFields.Calculators.length === calcKey + 1 ? 'no-border-bottom' : '')
      }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
        eventKey: calcKey.toString(),
        open: item === calcKey.toString(),
        onClick: handleItemClick(calcKey.toString())
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          width: '95%'
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-lg ".concat(calc.fields.Icon.value, "-black")
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "h3",
        style: {
          paddingLeft: '10px'
        }
      }, (0, _richTextField.parseHTML)(calc.fields.Title)), /*#__PURE__*/_react.default.createElement("div", {
        className: "calc-accordion-desc"
      }, item === calcKey.toString() ? '' : (0, _richTextField.parseHTML)(calc.fields.Description)))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
        eventKey: calcKey.toString()
      }, /*#__PURE__*/_react.default.createElement(_LoadCalculator.default, {
        items: calc.fields.StepsContent,
        type: calc.fields.Type.fields.calcType,
        env: props.params.env,
        apiUrl: calc.fields.Type.fields.apiUrl.value,
        showBorder: false,
        icon: "",
        title: "",
        sideBarBoxVariant: calc.fields.SideBarBoxVariant.value,
        hideNext: calc.fields.HideNext,
        CONTENT_API_CALC_PDF: "/apicalls/downloadpdf/calcpdf"
      })));
    })));
    return /*#__PURE__*/_react.default.createElement("div", {
      id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
      className: "app-container"
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
      variant: 'basic'
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, mainBody)));
  } else return null;
}
var _default = exports.default = CalculatorAccordion;